import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Timer } from 'lucide-react';

const MobileOfflineCountdown = ({ 
  isVisible, 
  countdown, 
  onCancel, 
  onComplete 
}) => {
  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed bottom-24 left-0 right-0 z-50 flex justify-center"
        initial={{ 
          width: 'auto',
          height: 'auto',
          scale: 1,
          borderRadius: '9999px'
        }}
        animate={{ 
          width: '100%',
          height: 'auto',
          scale: 1,
          borderRadius: '16px'
        }}
        exit={{ 
          width: 'auto',
          height: 'auto',
          scale: 0.8,
          borderRadius: '9999px'
        }}
        transition={{ 
          type: "spring", 
          damping: 25, 
          stiffness: 300, 
          duration: 0.4 
        }}
      >
        <motion.div
          className="w-full mx-4 bg-red-900/95 backdrop-blur-sm border-2 border-red-500/60 rounded-2xl p-4 shadow-[0_8px_32px_rgba(239,68,68,0.3)]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <Timer className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <h3 className="text-white font-semibold">Going Offline</h3>
                <p className="text-red-300 text-sm">Session ending in {countdown} seconds</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <motion.div
                className="text-2xl font-bold text-red-400"
                key={countdown}
                initial={{ scale: 1.2, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ type: "spring", damping: 15, stiffness: 400 }}
              >
                {countdown}
              </motion.div>
              
              <motion.button
                onClick={onCancel}
                className="w-8 h-8 bg-red-800/50 border border-red-600 rounded-full flex items-center justify-center hover:bg-red-700/50 transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <X className="w-4 h-4 text-red-300" />
              </motion.button>
            </div>
          </div>
          
          <motion.div
            className="mt-3 h-1 bg-red-800/50 rounded-full overflow-hidden"
            initial={{ width: '100%' }}
            animate={{ width: '0%' }}
            transition={{ 
              duration: countdown, 
              ease: "linear",
              onComplete: onComplete 
            }}
          >
            <div className="h-full bg-red-400 rounded-full" />
          </motion.div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default MobileOfflineCountdown;

